module.exports = __webpack_public_path__ + "static/img/logo_41.75c215e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_41.png
// module id = EzFw
// module chunks = 1